/** Possible states of an SdbBackgroundTask entity */

export let BackgroundTaskCategory = /*#__PURE__*/function (BackgroundTaskCategory) {
  /** Point cloud background task */
  BackgroundTaskCategory["pointCloud"] = "PointCloud";
  /** Video mode background task */
  BackgroundTaskCategory["videoMode"] = "VideoMode";
  /** CAD background task */
  BackgroundTaskCategory["cad"] = "Cad";
  /** Sphere Legacy migration task */
  BackgroundTaskCategory["migration"] = "Migration";
  return BackgroundTaskCategory;
}({});

/** Base props for a sdb background task entity */